import {useCachedT} from '@/services/useCachedI18n'
import {AssignmentStatus, AssignmentType} from '@/assignments/Assignment.type'
import {computed} from 'vue'

export function useAssignmentOptions(options: { includeAll?: boolean } = {}) {
    const {cachedT} = useCachedT()

    const statusOptions = computed(() => {
        const baseOptions = [
            {label: cachedT(`assignment.status.${AssignmentStatus.Pending}`), value: AssignmentStatus.Pending},
            {label: cachedT(`assignment.status.${AssignmentStatus.Completed}`), value: AssignmentStatus.Completed},
            {label: cachedT(`assignment.status.${AssignmentStatus.Deleted}`), value: AssignmentStatus.Deleted},
        ]
        if (options.includeAll) {
            return [{label: 'Alle oppgaver', value: 'all'}, ...baseOptions]
        }
        return baseOptions
    })

    const categoryOptions = computed(() => {
        const baseOptions = [
            {label: cachedT(`assignment.types.${AssignmentType.BookkeepIncomingEhf}`), value: AssignmentType.BookkeepIncomingEhf},
            {label: cachedT(`assignment.types.${AssignmentType.CreateSupplier}`), value: AssignmentType.CreateSupplier},
            {label: cachedT(`assignment.types.${AssignmentType.BookkeepDocument}`), value: AssignmentType.BookkeepDocument},
            {label: cachedT(`assignment.types.${AssignmentType.BookkeepOcrBankTransaction}`), value: AssignmentType.BookkeepOcrBankTransaction},
            {label: cachedT(`assignment.types.${AssignmentType.Approve}`), value: AssignmentType.Approve}
        ]
        if (options.includeAll) {
            return [{label: 'Alle kategorier', value: 'all'}, ...baseOptions]
        }
        return baseOptions
    })

    return {
        statusOptions: statusOptions,
        categoryOptions: categoryOptions
    }
}